import { Component, ojs, app, v, payload } from "modular-openscriptjs";
import { either, empty, formatThousand } from "../../../helpers";
import { api, uc } from "../../../declarations";
import { routes } from "../../../backendRoutes";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

/**
 * Renders a single company card in the "Favorite Companies" tab of the user profile.
 * Displays company logo, name, handle, rating, and an un-favorite action.
 */
export default class ProfileCompanyView extends Component {
    render(company, ...args) {
        let initial = company?.name ? company.name.charAt(0).toUpperCase() : '?';

        return h.div(
            {
                class: "biz-view-card h-100 rounded-4 border overflow-hidden position-relative shadow-sm text-decoration-none",
                $class: "col-12 col-md-6 col-lg-4 mb-3",
                role: "button",
                "data-company-id": company?.id,
                onclick: h.func("route.to", "business.view-profile", {
                    businessId: company?.id,
                }),
                ...args[0],
            },
            company?.cover_path ? h.div({
                class: "position-absolute top-0 start-0 w-100 h-100",
                style: `background: url('${company.cover_path}') no-repeat center center; background-size: cover; z-index: 0;`
            }) : h.div({
                class: "position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center overflow-hidden",
                style: `background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); z-index: 0;`
            },
                h.span({
                    class: "text-white fw-bold opacity-25 user-select-none",
                    style: "font-size: 10rem; transform: rotate(-15deg); line-height: 1;"
                }, initial)
            ),
            h.div(
                {
                    class: "position-absolute",
                    style: "top: 15px; right: 15px; z-index: 10;"
                },
                h.button(
                    {
                        class: "btn rounded-circle shadow-sm p-0 d-flex align-items-center justify-content-center border-0",
                        style: "width: 35px; height: 35px; background: rgba(220, 53, 69, 0.85); backdrop-filter: blur(4px); transition: transform 0.2s;",
                        title: "Remove from favorites",
                        listeners: {
                            click: (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                this.removeFavorite(company?.id);
                            },
                        },
                    },
                    h.i({ class: "fas fa-heart-broken text-white", style: "font-size: 0.95rem;" })
                )
            ),
            h.div(
                {
                    class: "d-flex flex-column h-100 position-relative w-100",
                    style: "z-index: 1; min-height: 200px;"
                },
                h.div({ class: "flex-fill w-100" }),
                h.div(
                    {
                        class: "p-2 d-flex gap-3 align-items-center w-100",
                        style: "background: rgba(0, 0, 0, 0.65);"
                    },
                    h.div(
                        { 
                            class: "flex-shrink-0 position-relative",
                            style: "width: 40px; height: 40px;"
                        },
                        company?.logo_path ? 
                        h.img(
                            {
                                class: "rounded shadow-sm position-absolute",
                                style: "width: 40px; height: 40px; object-fit: cover; top: 0; left: 0;",
                                src: company.logo_path
                            }
                        ) :
                        h.div(
                            {
                                class: "rounded shadow-sm position-absolute d-flex align-items-center justify-content-center fw-bold text-white fs-5",
                                style: "width: 40px; height: 40px; top: 0; left: 0; background: linear-gradient(135deg, #0d6efd 0%, #0098f0 100%);"
                            },
                            initial
                        )
                    ),
                    h.div(
                        { class: "flex-fill d-flex flex-column justify-content-center overflow-hidden" },
                        h.div({ class: "text-truncate fw-bold text-white mb-0" }, company?.name),
                        h.div({ class: "text-white-50 small" }, "@", company?.handle)
                    )
                )
            )
        );
    }

    async removeFavorite(companyId) {
        const res = await api.delete(`${routes.companyBookmarks}/${companyId}`);
        if (res) {
            // Remove card from DOM
            const card = document.querySelector(`[data-company-id="${companyId}"]`);
            if (card) {
                card.style.opacity = "0";
                card.style.transform = "scale(0.95)";
                card.style.transition = "opacity 0.25s, transform 0.25s";
                setTimeout(() => card.remove(), 260);
            }
        }
    }
}

ojs(ProfileCompanyView);
